// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3220":"fd070ee5","3948":"d60211e2","8211":"91707dd2","8844":"96e33348"}[chunkId] + ".chunk.css";
};